// src/pages/PricingPlan.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const packages = [
  {
    title: "Package 1",
    plan: "Monthly Subscription",
    price: "₹1333 / month",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹900 [Optional]", amount: 900 },
      {
        label: `3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]
• Meal plate pictures assessment
• Weekly Weight Assessment
• Blood Reports & Health Check-up assessment
• Supplement Guidance
• 30 mins Weekly Zoom call Consultation`,
        amount: 5100,
      },
    ],
  },
  {
    title: "Package 2",
    plan: "3 Months Subscription",
    price: "₹1999 / month",
    popular: true,
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹800 [Optional]", amount: 800 },
      {
        label: `3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]
• Meal plate pictures assessment
• Weekly Weight Assessment
• Blood Reports & Health Check-up assessment
• Supplement Guidance
• 30 mins Weekly Zoom call Consultation`,
        amount: 5100,
      },
    ],
  },
  {
    title: "Package 3",
    plan: "6 Months Subscription",
    price: "₹3700",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹800 [Optional]", amount: 800 },
      {
        label: `3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]
• Meal plate pictures assessment
• Weekly Weight Assessment
• Blood Reports & Health Check-up assessment
• Supplement Guidance
• 30 mins Weekly Zoom call Consultation`,
        amount: 5100,
      },
    ],
  },
  {
    title: "Package 4",
    plan: "Annual Subscription",
    price: "₹5500",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹900 [Optional]", amount: 900 },
      {
        label: `3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]
• Meal plate pictures assessment
• Weekly Weight Assessment
• Blood Reports & Health Check-up assessment
• Supplement Guidance
• 30 mins Weekly Zoom call Consultation`,
        amount: 5100,
      },
    ],
  },
];

const PricingPlan = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const planAmount = queryParams.get("plan");

  const selectedPlan = packages.find(
    (pkg) => pkg.price.replace(/[^0-9]/g, "") === planAmount,
  );

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    state: "",
    age: "",
    height: "",
    weight: "",
  });

  const [selectedAddOns, setSelectedAddOns] = useState([]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleAddOn = (amount) => {
    setSelectedAddOns((prev) =>
      prev.includes(amount)
        ? prev.filter((a) => a !== amount)
        : [...prev, amount],
    );
  };

  const baseAmount = selectedPlan ? Number(planAmount) : 0;
  const addOnAmount = selectedAddOns.reduce((sum, a) => sum + a, 0);
  const totalAmount = baseAmount + addOnAmount;

  const handlePayment = (e) => {
    e.preventDefault();

    if (!selectedPlan) {
      alert("Plan not found");
      return;
    }

    const amountInPaise = totalAmount * 100;

    const options = {
      key: "rzp_test_xxxxxxxx",
      amount: amountInPaise,
      currency: "INR",
      name: "Revibe Health & Happiness",
      description: selectedPlan.title,
      handler: function (response) {
        console.log("Payment Success:", response);
        navigate("/thank-you");
      },
      modal: {
        ondismiss: function () {
          console.log("Payment closed");
          navigate("/payment-failed");
        },
      },
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.phone,
      },
      theme: {
        color: "#22c55e",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      console.error("Payment Failed:", response.error);
      navigate("/payment-failed");
    });
    rzp1.open();
  };

  return (
    <section className="py-20 px-6 lg:px-20   bg-gradient-to-b from-gray-50 to-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {/* Left - Plan Info */}
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
          {selectedPlan ? (
            <>
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    {selectedPlan.title}
                  </h2>
                  <p className="text-lg text-gray-600">{selectedPlan.plan}</p>
                </div>
                <span className="text-3xl text-green-600 font-extrabold">
                  {selectedPlan.price}
                </span>
              </div>

              <div className="mt-6">
                <h3 className="font-semibold text-gray-800 mb-3">
                  Included Features:
                </h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  {selectedPlan.features.map((f, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-green-500 mr-2">✔</span> {f}
                    </li>
                  ))}
                </ul>
              </div>

              {selectedPlan.optional && (
                <div className="mt-6">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Optional Add-ons:
                  </h3>
                  <ul className="space-y-2 text-gray-700 text-sm">
                    {selectedPlan.optional.map((o, i) => (
                      <li key={i} className="flex items-start">
                        <input
                          type="checkbox"
                          id={`addon-${i}`}
                          className="mr-2 mt-1"
                          checked={selectedAddOns.includes(o.amount)}
                          onChange={() => toggleAddOn(o.amount)}
                        />
                        <label
                          htmlFor={`addon-${i}`}
                          className="cursor-pointer whitespace-pre-line"
                        >
                          {o.label}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          ) : (
            <p className="text-red-500">Plan not found</p>
          )}
        </div>

        {/* Right - Form */}
        <div className="bg-white rounded-2xl shadow-md p-8">
          <h3 className="text-xl font-semibold mb-6 text-gray-900">
            Complete Your Details
          </h3>

          <form className="space-y-6" onSubmit={handlePayment}>
            {/* Two-column grid for main fields */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your name"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Enter your phone number"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* City */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  placeholder="Enter your city"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* State */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  State <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  placeholder="Enter your state"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Optional Fields */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Age
                </label>
                <input
                  type="number"
                  name="age"
                  value={formData.age || ""}
                  onChange={handleChange}
                  placeholder="e.g. 25"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Height (cm)
                </label>
                <input
                  type="number"
                  name="height"
                  value={formData.height || ""}
                  onChange={handleChange}
                  placeholder="e.g. 170"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Weight (kg)
                </label>
                <input
                  type="number"
                  name="weight"
                  value={formData.weight || ""}
                  onChange={handleChange}
                  placeholder="e.g. 65"
                  className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>

            {/* Bill Summary */}
            <div className="bg-gray-50 border rounded-lg p-4 mt-6">
              <h4 className="font-semibold text-gray-800 mb-2">Bill Summary</h4>
              <div className="flex justify-between text-sm mb-1">
                <span>Base Plan</span>
                <span>₹{baseAmount}</span>
              </div>
              {selectedAddOns.map((a, i) => (
                <div key={i} className="flex justify-between text-sm mb-1">
                  <span>Add-on {i + 1}</span>
                  <span>₹{a}</span>
                </div>
              ))}
              <hr className="my-2" />
              <div className="flex justify-between font-bold text-green-600">
                <span>Total</span>
                <span>₹{totalAmount}</span>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600 mt-4"
            >
              Submit & Pay Now
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default PricingPlan;
